<div class="p-grid p-justify-even">
  <div class="p-col-12 p-mb-1">
    <p-dataView [value]="apps" [rows]="3" filterBy="name" layout="grid">
      <p-header>
        <h4>Apps disponibles</h4>
      </p-header>

      <ng-template let-app pTemplate="listItem">
        <div class="p-col-12">
          <div class="product-list-item">
            <img
              [src]="'assets/imagenes/apps/' + app.imgUrl"
              [alt]="app.name"
              style="max-width: 3rem;"
            />
            <div class="product-list-detail">
              <div class="product-name">{{ app.name }}</div>
              <div class="product-description">{{ app.description }}</div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template let-app pTemplate="gridItem">
        <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12">
          <p-card>
            <div class="p-grid">
              <img
                class="p-col"
                [src]="'assets/imagenes/apps/' + app.imgUrl"
                [alt]="app.name"
                style="max-width: 6rem;"
              />
              <h4 class="p-col">
                <a [href]="app.storeUrl" target="_blank">{{ app.name }}</a>
              </h4>
              <div class="p-col-12">{{ app.description }}</div>
            </div>
          </p-card>
        </div>
      </ng-template>
    </p-dataView>
  </div>
</div>
